"use client";

import type { CDescriptivePageContent } from "@/lib/api/cms-catalog";
import { useT } from "@/lib/i18n/context";
import { ParagraphRenderer } from "@/components/cms/Paragraphs/ParagraphRenderer";
import { cDescriptivePageTranslations } from "./CDescriptivePage.i18n";
import styles from "./CDescriptivePage.module.css";

export function CDescriptivePage({ content }: CDescriptivePageProps) {
  const t = useT(cDescriptivePageTranslations);

  if (!content || typeof content !== "object") {
    return <div className={styles.empty}>{t.emptyData}</div>;
  }

  return (
    <ParagraphRenderer
      paragraphs={Array.isArray(content.paragraphs) ? content.paragraphs : []}
      emptyMessage={t.emptyContent}
    />
  );
}

export type CDescriptivePageProps = {
  content: CDescriptivePageContent;
};
